import React from 'react';
import PromotionBadge from './PromotionBadge';
import '../scss/TyreDetails.scss';
import { TyreLabel, ApprovalBadge, SEASON } from './TyreLabel';
import { getFirstParagraph, hasRemainingContent } from '../utils/textUtils';

const TyreDetails = ({ tyre, onClose }) => {

	// Fonction pour scroller vers l'élément tyre-remaining-description
	const scrollToRemainingDescription = () => {
		const remainingElement = document.querySelector('.tyre-remaining-description');
		if (remainingElement) {
			remainingElement.scrollIntoView({ 
				behavior: 'smooth',
				block: 'start'
			});
		}
	};

	if (!tyre) return null;

	return (
		<div className="tyre-details">
			<div className="tyre-details-content">
				<div className="tyre-image-container">
					<img src={tyre.profile.imageUrl || '/wp-content/plugins/ax_tyres_catalog/app/build/svg/tyre-placeholder.jpg'} alt={tyre.description} className="tyre-image" />
					<div className="right-pictos">
						<TyreLabel type={tyre.season} value={SEASON[tyre.season] || tyre.season} />
						<div className="mspmsf">
							{tyre.pmsf && tyre.msMarked && (
								<img src={'/wp-content/plugins/ax_tyres_catalog/app/public/svg/ms-pmsf.svg'} alt="pmsf" />
							)}
							{tyre.pmsf && (
								<img src={'/wp-content/plugins/ax_tyres_catalog/app/public/svg/pmsf.svg'} alt="pmsf" />
							)}
							{tyre.msMarked && (
								<img src={'/wp-content/plugins/ax_tyres_catalog/app/public/svg/ms.svg'} alt="pmsf" />
							)}
						</div>
					</div>
					{tyre.promotions && tyre.promotions.length > 0 && (
						<PromotionBadge promotion={tyre.promotions[0]} />
					)}
				</div>
				<div className="tyre-info">
					<div className="tyre-info-header row">
						<div className="tyre-info-header-left col-8">
							<div className="tyre-brand">
								{tyre.brandLogo ? (
									<img src={tyre.brandLogo} alt={tyre.brand} />
								) : (
									<h4>{tyre.brand}</h4>
								)}
							</div>
							<div className="tyre-description-details">
								Pneu {SEASON[tyre.season]} {tyre.brand} 
								<div>
									{tyre.profile?.name || tyre.description}
								</div>
							</div>
							<div className="tyre-specs-container">
								<div className="tyre-specs">
									{tyre.width}/{tyre.height} R{tyre.radius} {tyre.loadIndex} {tyre.speedIndex}
									{tyre.reinforced && (
										<TyreLabel type="reinforced" value={tyre.reinforced} />
									)}
									{tyre.approvalLabel && (
										<ApprovalBadge label={tyre.approvalLabel} />
									)}
									{/* Labels spéciaux */}
									{tyre.crm && (
										<TyreLabel type="feature" value="crm" />
									)}
									{tyre.continentalSeal && (
										<TyreLabel type="feature" value="continentalSeal" />
									)}
									{tyre.continentalSilent && (
										<TyreLabel type="feature" value="continentalSilent" />
									)}
									{tyre.ev && (
										<TyreLabel type="feature" value="ev" />
									)}
									{tyre.runflatType && (
										<TyreLabel type="feature" value={tyre.runflatType} />
									)}
								</div> 
							</div>
						</div>
						<div className="tyre-info-header-right col-4">
							<div className="tyre-price">
								<span className="price">
									{tyre.formattedPrice}*
								</span>
								{tyre.isDiscount && (
									<span className="public-price">
									{tyre.formattedPublicPrice}
									</span>
								)}
								<span className="price-notice">
									*Prix unitaire TTC, exclusif internet
								</span>
							</div>
						</div>
					</div>				
					<div className="tyre-label-container">
						<TyreLabel type="fuel" value={tyre.fuelConsumption} />
						<TyreLabel type="grip" value={tyre.wetGrip} />
						<TyreLabel type="sound" value={tyre.soundLevel + 'dB'}/>
					</div>
					{tyre.profile?.description && (
						<>
							<div className="tyre-description">
								<div dangerouslySetInnerHTML={{ __html: getFirstParagraph(tyre.profile.description) }} />
								{hasRemainingContent(tyre.profile.description) && (
									<div 
										className="tyre-description-more"
										onClick={scrollToRemainingDescription}
										style={{ cursor: 'pointer' }}
									>
										Lire la suite
									</div>
								)}
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default TyreDetails; 